import { render } from "./Giphy.vue?vue&type=template&id=668208c7&scoped=true"
import script from "./Giphy.vue?vue&type=script&lang=js"
export * from "./Giphy.vue?vue&type=script&lang=js"

import "./Giphy.vue?vue&type=style&index=0&id=668208c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668208c7"]])

export default __exports__